import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useIsEmbeddedMode } from '../context/EmbeddedModeContext';
import { useConfig } from './queries/useConfig';

export const useWidgetLandingPageRedirect = () => {
  const isEmbeddedMode = useIsEmbeddedMode();
  const { data: chatbotConfig } = useConfig();
  const navigate = useNavigate();
  const location = useLocation();
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (
      !isEmbeddedMode ||
      !chatbotConfig ||
      !chatbotConfig.widgetLandingPage ||
      hasRedirected.current ||
      location.pathname !== '/'
    ) {
      return;
    }

    const targetPath = chatbotConfig.widgetLandingPage === 'intake' ? '/intake' : '/ai-chatbot';

    hasRedirected.current = true;
    navigate({ pathname: targetPath, search: location.search }, { replace: true });
  }, [isEmbeddedMode, chatbotConfig, navigate, location.pathname, location.search]);
};
